export default __webpack_public_path__ + "static/media/LocationOn.f57c1dfd.svg";